import { ODataObject } from '../../interfaces/odata-model.interface';
import { JsonTextModelOptions, TextModelOptions, TextModelOptionsFromJson } from '../options/text-model-options';
import { PrimitiveModel } from './primitive.model';

export class TextModel extends PrimitiveModel {
    public constructor(
        name: string,
        public value = '',
        public options = new TextModelOptions(),
    ) {
        super(name, value, options);
    }

    /**
     * Convert the internal data into an object suitable for OData exchange with SAP
     *
     * @returns {object} an object with 'name' as key and the value as value
     */
    public getOutModel(): ODataTextOutModel {
        const outModel: ODataTextOutModel = {};
        outModel[this.name] = this.value;
        return outModel;
    }
}

export class TextModelFromJson extends TextModel {
    public constructor(data: JsonTextModel) {
        super(data.name, data.value, new TextModelOptionsFromJson(data.options));
    }
}

export interface JsonTextModel {
    name: string;
    value: string;
    options: JsonTextModelOptions;
}

export interface ODataTextOutModel extends ODataObject {
    [key: string]: string;
}
